const LOAD_WAIT_TIME = 5000 // 5 seconds
export default {
  created() {
    this.$emit('load-start')
    this.startLoadTimeout()
  },
  watch: {
    src(newSrc) {
      if (newSrc) this.dispatchLoadStart()
    },
  },

  methods: {
    dispatchLoadStart() {
      this.$emit('load-start')
    },
    dispatchLoadEnd() {
      this.$emit('load-end')
    },
    onLoadEnd() {
      this.dispatchLoadEnd()
    },
    startLoadTimeout() {
      const timerId = setTimeout(() => {
        this.onLoadEnd()
        clearTimeout(timerId)
      }, LOAD_WAIT_TIME)
    },
  },
}
